import React, { useState , useEffect } from "react";
import styled from "@emotion/styled";
import { FaChevronDown } from "react-icons/fa";
import AmenityDetails from "../AmenityDetails";
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  width: 100%;
  max-width: 900px;
`;

const RequestCard = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AmenityInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;

    @media (max-width: 768px) {
    display:flex;
    flex-direction:column;
  }
`;

const Button = styled.button`
  padding: 10px;
  border: none;
  border-radius: 4px;
  color: white;
  background-color: ${(props) => props.bg || "#385963"};
  cursor: pointer;
  display: flex;
  align-items: center;

   @media (max-width: 768px) {
    margin-left: 5px;
    font-size: 10px;
    padding:5px;
    justify-content: center;
    text-align: center;      
  }
`;

const CollapsibleContent = styled.div`
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
`;

const CommentBox = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  resize: vertical;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const SubmitCommentBtn = styled.button`
  margin-top: 0.5rem;
  padding: 10px 20px;
//   background-color: #ff9800;
background-color: #385963;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const CommentSection = styled.div`
  display:flex;
  flex-direction:column;
  gap: 10px;
  margin-top: 10px;

   @media (max-width: 768px) {
    font-size: 14px;
    align-items:center;
    text-align:center;
    justify-content:center;
  }
`;


// FilePlaceTypeEnum
const request_status = {
   Pending :0 ,
   Approved: 1,
   Rejected: 2,
   ForRevision:3

};

const AmenityRequests = () => {

 const tokenString = sessionStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [expandedAmenityId, setExpandedAmenityId] = useState(null);
  const [comments, setComments] = useState({});
  const [loading, setLoading] = useState(false);
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [amenities, setAmenities] = useState([]);
  const [fetching, setFetching] = useState(true); 

  const formatDateTime = (isoString) =>
    new Date(isoString).toLocaleString(selectedLanguage, {
      dateStyle: "medium",
      timeStyle: "short",
    });

useEffect(() => {
  const fetchAmenities = async () => {
    try {
      const requestBody = {
        categoryId: null,  // fix categoryId as discussed earlier
        providerId: null,    // or actual user id if available
        status: 0,
        model: {}
      };

      const response = await fetch(`${BASE_URL}Amenity/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}`
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      // Suppose your array is inside data.items
      setAmenities(Array.isArray(data) ? data : data.items || []);
    } catch (error) {
      console.error("Error fetching amenities:", error);
      setAmenities([]);
    }
  };

  fetchAmenities();
}, []);


  const toggleExpand = (id) => {
    setExpandedAmenityId((prevId) => (prevId === id ? null : id));
  };

  const handleCommentChange = (amenityId, value) => {
    setComments((prev) => ({ ...prev, [amenityId]: value }));
  };

   const submitComment = async (amenityId) => {
    const comment = comments[amenityId];
    if (!comment || comment.trim() === "") {
      alert("Please enter a comment before submitting.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}Amenity/${amenityId}/updateStatus`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify({
          newStatus: request_status.ForRevision,
          comment: comment,
        }),
      });

      if (!res.ok) throw new Error("Failed to update amenity status");

      alert("Comment submitted and status updated to 'For Revision'");
      setComments((prev) => ({ ...prev, [amenityId]: "" }));
      setExpandedAmenityId(null);

      // Optionally refresh list
      setAmenities(prev => prev.filter(a => a.id !== amenityId));
    } catch (error) {
      alert("Error submitting comment: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const rejectRequest = async (amenityId) => {
    const comment = comments[amenityId];
    // if (!comment || comment.trim() === "") {
    //   alert("Please enter a comment before rejecting.");
    //   return;
    // }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}Amenity/${amenityId}/updateStatus`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify({
          newStatus: request_status.Rejected,
          comment: "rejected by admin",
        }),
      });

      if (!res.ok) throw new Error("Failed to reject amenity");

      alert("Amenity rejected with comment.");
      setComments((prev) => ({ ...prev, [amenityId]: "" }));
      setExpandedAmenityId(null);
      setAmenities(prev => prev.filter(a => a.id !== amenityId));
    } catch (error) {
      alert("Error rejecting amenity: " + error.message);
    } finally {
      setLoading(false);
    }
  };

 const approveRequest = async (amenityId) => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}Amenity/${amenityId}/updateStatus`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify({
          newStatus: request_status.Approved,
          comment: "Approved by admin",
        }),
      });

      if (!res.ok) throw new Error("Failed to approve amenity");

      alert("Amenity approved successfully.");
      setExpandedAmenityId(null);
      setAmenities(prev => prev.filter(a => a.id !== amenityId));
    } catch (error) {
      alert("Error approving amenity: " + error.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Container>
      {/* {amenities.length === 0 ? ( */}
      {!Array.isArray(amenities) || amenities.length === 0 ? (
        <p> {t('noPendingAmenityRequests')}</p>
      ) : (
       amenities.map((amenity) => (
          <RequestCard key={amenity.id}>
            <HeaderRow>
              <AmenityInfo>
                <div>
                  <strong>{amenity.name[selectedLanguage]}</strong>
                </div>
                 <div>
                  {amenity.providerName}
                </div>
              </AmenityInfo>
              <Actions>
                <Button bg="#4CAF50" onClick={() => approveRequest(amenity.id)}>
                  {t("approve")}
                </Button>
                  <Button bg="#d9534f" onClick={() => rejectRequest(amenity.id)}>
                  {t("reject")}
                </Button>
                <Button bg="#385963" onClick={() => toggleExpand(amenity.id)}>
                  {t("details")}
                  <FaChevronDown
                    style={{
                      marginLeft: "8px",
                      transition: "transform 0.3s",
                      transform:
                        expandedAmenityId === amenity.id ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </Button>
              </Actions>
            </HeaderRow>

            {expandedAmenityId === amenity.id && (
              <CollapsibleContent>
                <AmenityDetails amenity={amenity} />

                {/* Admin comment section */}
                <CommentSection>
                  <label htmlFor={`comment-${amenity.id}`}>
                    <strong>  {t('addCommentForRevision')}:</strong>
                  </label>
                  <CommentBox
                    id={`comment-${amenity.id}`}
                    value={comments[amenity.id] || ""}
                    onChange={(e) => handleCommentChange(amenity.id, e.target.value)}
                    placeholder={i18n.t('writeCommentHere')}
                    disabled={loading}
                  />
                  <SubmitCommentBtn
                    onClick={() => submitComment(amenity.id)}
                    disabled={loading}
                  >
                    {t('submitCommentRequestRevision')}
                  </SubmitCommentBtn>
                </CommentSection>
              </CollapsibleContent>
            )}
          </RequestCard>
        ))
      )}
    </Container>
  );
};

export default AmenityRequests;
